import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PrimaryCategory = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.serviceSales.filters.primary_categories);
  const selectedOptions = useSelector(
    (state) => state.serviceSales.selectedFilters.primary_categories
  );

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOptions}
      placeholder="Primary Categories"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      height={324}
      onSelectChange={(data) => dispatch(actionCreators.updatePrimaryCategory(data))}
    />
  );
};

export default PrimaryCategory;
